module.exports = __webpack_public_path__ + "img/not-ok.908c962d.png";